// Copy for the single-number edit modal, keyed by the preference it edits.
export const MODAL_TITLES = {
  max_auto_approve_amount: "Maximum auto-approve amount",
  repeat_disputer_threshold: "Repeat-disputer threshold",
  ignore_below_amount: "Skip disputes below this amount"
}

export const MODAL_DESCRIPTIONS = {
  max_auto_approve_amount:
    "Auto-approve only fires at or below this limit. Larger disputes wait for you.",
  repeat_disputer_threshold:
    "Once a customer has filed this many disputes against you in total, Recover stops auto-submitting their disputes and sends them to your team to review by hand.",
  ignore_below_amount:
    "Disputes under this amount are not auto-submitted. Recover marks them Skipped, so you pay no submission fee and spend no time on them. They stay in your queue if you ever want to handle one yourself."
}
